import { HomeGenerateSection } from './home-generate-section'

export function ImageToVideoSection() {
  return <HomeGenerateSection />
}
